import React from 'react';
import { DefaultBackground, CobrandingComponents } from '../shared-cobranding';
import { CommunityLogo } from '../../../advanced-cobranding/community/assets/images/CommunityLogo';

const CommunityCobranding: CobrandingComponents = {
  background: DefaultBackground,
  logo: { renderLogo: () => <CommunityLogo /> },
  footerProducts: 'Community, Jira, Confluence',
};

export default CommunityCobranding;
